module.exports = __webpack_public_path__ + "img/i18n.11cf792.svg";